import React from 'react';
import { Button, Tooltip } from 'antd';
import { PlusOutlined, InboxOutlined } from '@ant-design/icons';

export interface CycleDetailHeaderBarProps {
  cycle: any;
  isMobile?: boolean;
  onOpenLogModal: () => void;
  onBack: () => void;
  onEditConfig: () => void;
  onGoToStorage: () => void;
  onOpenClosingModal: () => void;
}

export const CycleDetailHeaderBar: React.FC<CycleDetailHeaderBarProps> = ({
  cycle,
  isMobile = false,
  onOpenLogModal,
  onBack,
  onEditConfig,
  onGoToStorage,
  onOpenClosingModal,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: isMobile ? '16px' : '24px',
        flexWrap: 'wrap',
        gap: '12px',
      }}
    >
      <h2 style={{ margin: 0, fontSize: isMobile ? '18px' : '24px' }}>
        📝 Ciclo: {cycle.name}
      </h2>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 8,
          width: isMobile ? '100%' : 'auto',
        }}
      >
        {cycle.status === 'ACTIVE' && (
          <Button
            type="primary"
            onClick={onOpenLogModal}
            icon={<PlusOutlined />}
            style={{
              flex: isMobile ? '1 1 100%' : 'initial',
              height: isMobile ? 38 : undefined,
              fontWeight: 600,
            }}
          >
            Registrar Evento (Log)
          </Button>
        )}
        <Button
          onClick={onBack}
          style={{ flex: isMobile ? '1 1 calc(50% - 4px)' : 'initial' }}
        >
          Volver Lista
        </Button>
        <Button
          onClick={onEditConfig}
          style={{ flex: isMobile ? '1 1 calc(50% - 4px)' : 'initial' }}
        >
          Editar Config
        </Button>
        {cycle.status === 'ACTIVE' && (
          <>
            <Tooltip title="Módulo especializado de inventario para compras avanzadas, traslados entre bodegas o ajustes masivos fuera del flujo directo del ciclo">
              <Button
                onClick={onGoToStorage}
                icon={<InboxOutlined />}
                style={{ flex: isMobile ? '1 1 calc(50% - 4px)' : 'initial' }}
              >
                Módulo Almacén
              </Button>
            </Tooltip>
            <Button
              danger
              onClick={onOpenClosingModal}
              style={{ flex: isMobile ? '1 1 calc(50% - 4px)' : 'initial' }}
            >
              Cerrar Ciclo
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
